'use client';
import { AllApiKeys } from './AllApiKeys';
import { TableViewerLayout } from '@components/TableViewerLayout/TableViewerLayout';
import '../page.css';
import { ApiKeyDetails } from './ApiKeyDetails';

const ApiKeysPage = () => {
  return (
    <TableViewerLayout
      tableTitle='All API Keys'
      tableSlot={<AllApiKeys />}
      viewerTitle='API Key Details'
      viewerSlot={<ApiKeyDetails />}
    />
  );
};

export default ApiKeysPage;